import type { OnboardingStep } from './step';

/* ----- The answer value sets the wizard collects ----- */

export type Outcome = 'wellbeing-space' | 'embedded-tools' | 'not-sure';

export type DigitalSetup = 'no-platform' | 'has-website' | 'has-dev-team';

export type Priority = 'speed' | 'integration' | 'grow';

export type HostedTier = 'standard' | 'custom';

export type AudienceCategory = 'education' | 'healthcare' | 'other-companies';
export type AudienceType = 'staff' | 'students' | 'both' | 'patients';

/** The JAAQ solution the wizard recommends, and the one the user ultimately chooses. */
export const VARIANTS = ['hosted', 'embedded'] as const;
export type Variant = (typeof VARIANTS)[number];

/* ----- The accumulated onboarding state ----- */

export type OnboardingState = {
  currentStep: OnboardingStep;
  outcomes?: Outcome[];
  digitalSetups?: DigitalSetup[];
  priority?: Priority;
  recommendedVariant?: Variant;
  audience?: { category: AudienceCategory; audienceType: AudienceType };
  hostedTier?: HostedTier;
};

export const INITIAL_STATE: OnboardingState = {
  currentStep: 'outcome',
};

/** The slice of state the step-navigation helpers need. */
export type StepState = Pick<OnboardingState, 'recommendedVariant'>;
